/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_RetryInputs */

const en_us2_intake_retry = /** @type {(inputs: Intake_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was lost. Press again and it will pick up where it stopped.`)
};

const pt_br2_intake_retry = /** @type {(inputs: Intake_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada foi perdido. Toque de novo e ele continua de onde parou.`)
};

const es_419_intake_retry = /** @type {(inputs: Intake_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se perdió nada. Toca de nuevo y continuará donde se quedó.`)
};

const pt_pt2_intake_retry = /** @type {(inputs: Intake_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada se perdeu. Toca outra vez e continua de onde parou.`)
};

const fr_fr2_intake_retry = /** @type {(inputs: Intake_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien n'a été perdu. Touche à nouveau et ça reprendra là où ça s'est arrêté.`)
};

const de_de2_intake_retry = /** @type {(inputs: Intake_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts ist verloren. Tippe noch mal, und es geht dort weiter, wo es aufgehört hat.`)
};

const it_it2_intake_retry = /** @type {(inputs: Intake_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non si è perso nulla. Tocca di nuovo e riprende da dove si era fermato.`)
};

/**
* | output |
* | --- |
* | "Nothing was lost. Press again and it will pick up where it stopped." |
*
* @param {Intake_RetryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_retry = /** @type {((inputs?: Intake_RetryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_RetryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_retry(inputs)
	if (locale === "es-419") return es_419_intake_retry(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_retry(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_retry(inputs)
	if (locale === "de-DE") return de_de2_intake_retry(inputs)
	if (locale === "it-IT") return it_it2_intake_retry(inputs)
	return en_us2_intake_retry(inputs)
});
export { intake_retry as "intake.retry" }